import { WidgetZoneUsageSummaryDTO } from './widget-zone-usage-summary.dto';

export interface BundleDTO {
  avgMBPerSim     : number | null;
  bundleCode      : string;
  bundleId        : number | null;
  bundleName      : string;
  countriesCount  : number | null;
  dataWeightCode  : string;
  remaining       : number | null;
  resetDate       : Date   | string | null;
  resetPeriod     : string;
  systemZoneCount : number | null;
  totalAllowance  : number | null;
  used            : number | null;
  zoneNames       : string[];
};

export interface CompanyDataBundleUsageDTO {
  bundles                       : BundleDTO[]                | null;
  outOfBundleZones              : WidgetZoneUsageSummaryDTO[]| null;
  totalOutOfBundleCost          : number                     | null;
  totalOutOfBundleCostWithSymbol: string;
  totalOutOfBundleUsageGB       : number                     | null;
};

export function CompanyDataBundleUsageDTO_EmptyObject(): CompanyDataBundleUsageDTO {
  return {
    bundles                       : [],
    outOfBundleZones              : [],
    totalOutOfBundleCost          : 0,
    totalOutOfBundleCostWithSymbol: "£0.00",
    totalOutOfBundleUsageGB       : 0
  };
};
